const SVG_PRESENTATION_PROPERTIES = [
  'fill',
  'stroke',
  'font-family',
  'font-weight',
  'text-anchor',
];

export const captureAnnotationsOverlay = (container: HTMLElement) => {
  const overlay = container.querySelector<SVGSVGElement>(
    'svg[data-component="annotations-overlay"]',
  );
  if (!overlay) {
    return null;
  }

  const clone = overlay.cloneNode(true) as SVGSVGElement;
  const originals = [overlay, ...overlay.querySelectorAll<SVGElement>('*')];
  const copies = [clone, ...clone.querySelectorAll<SVGElement>('*')];
  originals.forEach((element, index) => {
    const style = getComputedStyle(element);
    SVG_PRESENTATION_PROPERTIES.forEach((property) => {
      copies[index].style.setProperty(property, style.getPropertyValue(property));
    });
  });
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  clone.setAttribute('width', String(overlay.viewBox.baseVal.width));
  clone.setAttribute('height', String(overlay.viewBox.baseVal.height));
  return new XMLSerializer().serializeToString(clone);
};

export const composeAnnotationsOverlay = async ({
  image,
  overlay,
}: {
  image: Blob;
  overlay: string | null;
}) => {
  if (!overlay) {
    return image;
  }

  const imageUrl = URL.createObjectURL(image);
  const overlayUrl = URL.createObjectURL(new Blob([overlay], {
    type: 'image/svg+xml;charset=utf-8',
  }));
  try {
    const background = new Image();
    const annotations = new Image();
    background.src = imageUrl;
    annotations.src = overlayUrl;
    await Promise.all([background.decode(), annotations.decode()]);

    const canvas = document.createElement('canvas');
    canvas.width = background.naturalWidth;
    canvas.height = background.naturalHeight;
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Unable to create the annotation export canvas');
    }
    context.drawImage(background, 0, 0);
    context.drawImage(annotations, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, 'image/png');
    });
    if (!blob) {
      throw new Error('Unable to encode the annotated image');
    }
    return blob;
  } finally {
    URL.revokeObjectURL(imageUrl);
    URL.revokeObjectURL(overlayUrl);
  }
};
